import React from 'react'
import { propEq } from 'ramda'
import { connect } from 'react-redux'
import { localizedTranslate } from 'assets/localization'

const RenderHint = props => {
  // const surveys = pathOr([], ['currentProject', 'surveys'], props)
  // const onlyHasDefaultQuestions = survey => (survey.numQuestions && survey.numQuestions === 2)
  // const unlaunchedSurvey = pathEq(['status', 'status'], 0)
  // const anySurveyNeedsScreener = surveys.some(onlyHasDefaultQuestions)
  // const hasntLaunched = surveys.some(unlaunchedSurvey)
  const projectIsComplete = propEq('projectStatusId', 4, props.currentProject)
  const projectIsFinalizing = propEq('projectStatusId', 7, props.currentProject)
  const messageToRender = (() => {
    if (props.showAvailabilityWarning) return props.t("unavailable.moderators.message")
    // if (anySurveyNeedsScreener) return "Add screener questions to your Inactive Screeners.
    // This will allow you to match with the participants you're looking for."
    // if (hasntLaunched) return 'When you\'re ready to start fielding, hit "Launch all Screeners",
    // or individually launch specific ones under Inactive Screeners.'
    return ''
  })()
  return messageToRender && !projectIsFinalizing && !projectIsComplete ? (
    <div className="hint-box">
      <div className="hint">{messageToRender}</div>
    </div>
    ) : null
}

const mapState = state => ({
  currentProject: state.currentProject,
  t: localizedTranslate('en', state.translations.en_us),
})

export default connect(mapState)(RenderHint)
